export type StatusBadgeVariant = 'in_transit' | 'delayed' | 'arrived' | 'pending' | 'completed'

interface StatusBadgeProps {
  status: StatusBadgeVariant
  label: string
}

const StatusBadge = ({ status, label }: StatusBadgeProps) => {
  const statusStyles = {
    in_transit: 'bg-blue-50 text-blue-700 border-blue-200',
    delayed: 'bg-red-50 text-red-700 border-red-200',
    arrived: 'bg-green-50 text-green-700 border-green-200',
    pending: 'bg-yellow-50 text-yellow-700 border-yellow-200',
    completed: 'bg-green-50 text-green-700 border-green-200',
  }

  return (
    <span
      className={`inline-flex items-center px-3 py-1 rounded-md text-xs font-medium border whitespace-nowrap ${statusStyles[status]}`}
    >
      {label}
    </span>
  )
}

export default StatusBadge

